import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Log } from './log.model';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable()
export class LogsService {
    constructor(private http: HttpClient) { }

    changeLevel(log: Log): Observable<Log> {
        return this.http.put<Log>('management/logs', log);
    }

    findAll(): Observable<Log[]> {
        return this.http.get<Log[]>('management/logs').map((res: Log[]) => res);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/logs/logs.service.ts